// removed by extract-text-webpack-plugin
module.exports = {"container":"_1diTHoUe11WcFSB-MGQnqr","logos":"_2X3_Q7maOVHyV6uIbXdMnn","big":"_3pNFT9lK20fM6JHaUOpyeq","small":"_1_IFMYvWBb_8hDsXXCGUWL","impressum":"KuiO-73_R13EM8bTKZoAY"};


//////////////////
// WEBPACK FOOTER
// ../components/Footer/style.module.less
// module id = 935
// module chunks = 0